import { ReactNode } from 'react';
import { BoloSearchTabsProvider } from './bolo-search-tabs-provider';

export function BoloSearchProvider({
    initialTab,
    children,
}: {
    initialTab: string;
    children: ReactNode;
}) {
    return <BoloSearchTabsProvider initialTab={initialTab}>{children}</BoloSearchTabsProvider>;
}
